/* eslint-disable */
export const D360_GET_REPORT_START = 'D360_GET_REPORT_START';
export const D360_GET_REPORT_SUCCESS = 'D360_GET_REPORT_SUCCESS';
export const D360_GET_REPORT_FAIL = 'D360_GET_REPORT_FAIL';
